module.exports = __webpack_public_path__ + "img/thumbnail_WesternChimpanzee_j_normal.7d25cc2d.png";